import type { BlokProps } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import { Button } from "@/components/ui/Button";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokButton } from "@/storyblok";

export const ButtonBlok = ({ blok }: BlokProps<BlokButton>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<Button href={sbLink(blok.link)?.href}>{blok.text}</Button>
		</BlokWrap>
	);
};
